module.exports = __webpack_public_path__ + "static/media/logo-harvard-bmi-off.d000d211.svg";